"use client";

import { c as _c } from "react/compiler-runtime";
import { RateChangeType } from "./DropListItemRateGive";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { ProfileConnectedStatus } from "@/entities/IProfile";
export default function DropListItemRateGiveChangeButton(t0) {
  const $ = _c(29);
  const {
    type,
    canVote,
    handleMouseDown,
    handleMouseUp,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const {
    connectionStatus
  } = useContext(AuthContext);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [RateChangeType.INCREASE]: "M18 15L12 9L6 15",
      [RateChangeType.DECREASE]: "M6 9L12 15L18 9"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const svgpaths = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      [RateChangeType.INCREASE]: "Choose positive votes",
      [RateChangeType.DECREASE]: "Choose negative votes"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const ariaLabels = t3;
  let t4;
  if ($[2] !== connectionStatus || $[3] !== handleMouseDown || $[4] !== type) {
    t4 = () => {
      if (connectionStatus !== ProfileConnectedStatus.HAVE_PROFILE) {
        return;
      }
      handleMouseDown(type);
    };
    $[2] = connectionStatus;
    $[3] = handleMouseDown;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onMouseDown = t4;
  let t5;
  if ($[6] !== connectionStatus || $[7] !== handleMouseUp) {
    t5 = () => {
      if (connectionStatus !== ProfileConnectedStatus.HAVE_PROFILE) {
        return;
      }
      handleMouseUp();
    };
    $[6] = connectionStatus;
    $[7] = handleMouseUp;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onMouseUpOrLeave = t5;
  const getButtonClasses = _temp;
  const [buttonClasses, setButtonClasses] = useState(getButtonClasses(canVote));
  let t6;
  let t7;
  if ($[9] !== canVote) {
    t6 = () => {
      setButtonClasses(getButtonClasses(canVote));
    };
    t7 = [canVote];
    $[9] = canVote;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let t8;
  if ($[12] !== onMouseDown) {
    t8 = e => {
      e.stopPropagation();
      onMouseDown();
    };
    $[12] = onMouseDown;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onMouseUpOrLeave) {
    t9 = e_0 => {
      e_0.stopPropagation();
      onMouseUpOrLeave();
    };
    $[14] = onMouseUpOrLeave;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = !canVote;
  const t11 = ariaLabels[type];
  const t12 = `tw-flex tw-items-center tw-justify-center tw-border-0 tw-rounded-lg tw-ring-1 tw-ring-iron-700/50 tw-text-iron-300 tw-transition-all tw-duration-300 ${isMobile ? "tw-bg-iron-800 tw-size-10 active:tw-bg-iron-600 active:tw-scale-95" : "tw-bg-iron-900 tw-size-6 hover:tw-bg-iron-800 hover:tw-ring-iron-600/50 hover:tw-text-iron-200"} tw-transition-all tw-duration-150 ${buttonClasses}`;
  const t13 = `${isMobile ? "tw-size-6" : "tw-size-4"} tw-rotate-90 tw-flex-shrink-0`;
  const t14 = svgpaths[type];
  let t15;
  if ($[16] !== t14) {
    t15 = <path d={t14} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t13 || $[19] !== t15) {
    t16 = <svg className={t13} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t15}</svg>;
    $[18] = t13;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== onMouseUpOrLeave || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t16 || $[26] !== t8 || $[27] !== t9) {
    t17 = <button type="button" onMouseDown={t8} onMouseUp={t9} onMouseLeave={onMouseUpOrLeave} onClick={_temp2} disabled={t10} aria-label={t11} className={t12}>{t16}</button>;
    $[21] = onMouseUpOrLeave;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t16;
    $[26] = t8;
    $[27] = t9;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}
function _temp(ratingAllowed) {
  if (ratingAllowed) {
    return "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-700 tw-text-iron-300";
  }
  return "tw-text-iron-500";
}